import SyncListPage from './SyncListPage'

export default SyncListPage
